import { useCallback, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ComponentActions } from '../components.style';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import ComponentAltTextButton from '../shared/component-alt-text/component-alt-text-button';
import { EditProps } from './image-sphere.constants';
import ImageSphereCreate from './image-sphere-create';
import { ImageContainer } from '../image/image.style';
import { ImageViewFill } from '../image/image-view';
import ImageSphereTag from './image-sphere-tag';
import ImageSphereEditModalWrapper from './image-sphere-edit-modal';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';

const ImageSphereEdit = (props: EditProps) => {
  const { id, sectionId, properties } = props;
  const [newFileProps, setNewFileProps] = useState<{
    key: string;
    fileName: string;
    file: File;
  }>();

  const { isVisible, openModal, closeModal } = useSimpleModalState();
  const { activeComponent } = useActivityBuilderContext();
  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const handleUpdateHeight = useCallback(
    (width: number, height: number) => {
      const dimensionData = {
        ...properties.dimensionData,
        width,
        height: Math.floor(height),
      };
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData,
            },
          },
        },
        properties: {
          ...properties,
          dimensionData,
        },
        typename: 'ActivitiesImageSphereComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleUpdateHeight}
    >
      {isVisible && (
        <ImageSphereEditModalWrapper
          {...props}
          fileToUpload={newFileProps}
          onClose={closeModal}
        />
      )}
      {properties.image ? (
        <>
          <ImageContainer $fullBorderRadius={!properties.showCaptionOnLesson}>
            <ImageViewFill imageUrls={properties.printImageUrls || []} />
          </ImageContainer>
          <ComponentActions>
            <ComponentAltTextButton
              hasAltText={!!properties.altText}
              onClick={openModal}
            />
          </ComponentActions>
          <ImageSphereTag />
        </>
      ) : (
        <FileDropperContextProvider>
          <ImageSphereCreate
            {...props}
            onShowModal={newFileProps => {
              setNewFileProps(newFileProps);
              openModal();
            }}
          />
        </FileDropperContextProvider>
      )}
    </ComponentDimensions>
  );
};

export default ImageSphereEdit;
